// hooks
import React, { useContext, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

// components
import { Col, Row } from 'react-bootstrap';
import OrangeLine from '../../components/OrangeLine';
import Button from '../../components/Button';
import GlobalContext from '../../components/GlobalContext';
import { useLocation } from 'react-router';
import './PricesNewEnglish.css';
import usaFlag from './../../assets/images/flags/DELAWARE.svg';
import chinaFlag from './../../assets/images/flags/CHINA.svg';
import turkeyFlag from './../../assets/images/flags/TURKEY.svg';
import greeceFlag from './../../assets/images/flags/GREECE.svg';

export default function PricesNewEnglish({ route, navigation }) {
  const { t } = useTranslation();
  const { setShowCalculator } = useContext(GlobalContext);
  const { hash } = useLocation();
  const ref = useRef();

  const showCalculatorHandler = () => {
    setShowCalculator(true);
  };

  useEffect(() => {
    if (hash === '#prices') {
      ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start', alignToTop: true });
    }
  }, []);

  const [activeTab, setActiveTab] = React.useState('all');

  return (
    <div>
      <link href='https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0-beta3/css/all.min.css' rel='stylesheet'></link>
      <Row className='prices-row' id='prices'>
        <Col lg={12} md={12} xs={12} style={{ padding: '0 25px' }}>
          <div className='prices-right-div'>
            <OrangeLine />
            <h2 className='about-us-title mt-2' style={{ marginBottom: 10 }}>
              International Shipping Rates
            </h2>

            <div className='tabs'>
              <div className={`tab ${activeTab === 'all' && 'active'}`} onClick={() => setActiveTab('all')}>
                ALL
              </div>
              <div className={`tab ${activeTab === 'usa' && 'active'}`} onClick={() => setActiveTab('usa')}>
                USA
              </div>
              <div className={`tab ${activeTab === 'china' && 'active'}`} onClick={() => setActiveTab('china')}>
                CHINA
              </div>
              <div className={`tab ${activeTab === 'turkey' && 'active'}`} onClick={() => setActiveTab('turkey')}>
                TURKEY
              </div>
              <div className={`tab ${activeTab === 'greece' && 'active'}`} onClick={() => setActiveTab('greece')}>
                GREECE
              </div>
            </div>
          </div>
          <div className='pricing-container'>
            {(activeTab === 'all' || activeTab === 'usa') && (
              <div className='country-section'>
                <div className='country-header'>
                  <div className='country-flag'>
                    <img style={{ width: 20 }} src={usaFlag} />
                  </div>
                  <div className='country-name'>USA</div>
                </div>

                <div className='shipping-options'>
                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-plane-departure'></i> Standard Shipping
                      </h3>
                      <p className='method-description'>Regular air freight service from USA to Georgia</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>Standard Rate</div>
                          <div className='price-value'>$9/kg</div>
                          <div className='price-details'>All packages</div>
                        </div>
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>Cost calculated using maximum of volumetric and scale weights</li>
                          <li>Delivery time: 7-10 business days</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {(activeTab === 'all' || activeTab === 'china') && (
              <div className='country-section'>
                <div className='country-header'>
                  <div className='country-flag'>
                    <img style={{ width: 20 }} src={chinaFlag} />
                  </div>
                  <div className='country-name'>CHINA</div>
                </div>

                <div className='shipping-options'>
                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-plane-departure'></i> Air Shipping
                      </h3>
                      <p className='method-description'>Fast air freight service from China to Georgia</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>Standard Rate</div>
                          <div className='price-value'>$12/kg</div>
                          <div className='price-details'>All packages</div>
                        </div>

                        {/* <div className='price-card promo'>
                          <div className='price-type'>Promotional</div>
                          <div className='price-value'>$9/kg</div>
                          <div className='price-details'>Limited time offer</div>
                          <div className='price-badge'>Jun 1 - Sep 1</div>
                        </div> */}
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>Cost calculated using maximum of volumetric and scale weights</li>
                          <li>Delivery time: 5-8 business days</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-truck-moving'></i> Road Shipping
                      </h3>
                      <p className='method-description'>Cost-effective land transportation</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>Standard Rate</div>
                          <div className='price-value'>$5.5/kg</div>
                          <div className='price-details'>All packages</div>
                        </div>

                        {/* <div className='price-card promo'>
                          <div className='price-type'>Promotional</div>
                          <div className='price-value'>$2.5-3.5/kg</div>
                          <div className='price-details'>
                            Up to 30kg: $3.5/kg
                            <br />
                            Over 30kg: $2.5/kg
                          </div>
                          <div className='price-badge'>Jun 1 - Sep 1</div>
                        </div> */}
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>Under 30kg volumetric → charged by scale weight</li>
                          <li>Packages of 30kg and above in volumetric or actual weight - charged by the maximum between volumetric and scale weights</li>
                          <li>Delivery time: 30-45 business days</li>
                        </ul>
                      </div>
                    </div>
                  </div>

                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-truck-loading'></i> Road Cargo
                      </h3>
                      <p className='method-description'>Bulk shipping for large orders</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>Standard Rate</div>
                          <div className='price-value'>$220/m³</div>
                          <div className='price-details'>Minimum chargeable: 1 CBM</div>
                          <div className='price-details'>Maximum density: 250 kg per CBM</div>
                          {/* <div className='price-badge'>Jun 1 - Sep 1</div> */}
                        </div>
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>Volume-based pricing</li>
                          <li>Minimum order: 1 CBM</li>
                          <li>Delivery time: 30-45 business days</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {(activeTab === 'all' || activeTab === 'turkey') && (
              <div className='country-section'>
                <div className='country-header'>
                  <div className='country-flag'>
                    <img style={{ width: 20 }} src={turkeyFlag} />
                  </div>
                  <div className='country-name'>TURKEY</div>
                </div>

                <div className='shipping-options'>
                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-truck-loading'></i> Standard Shipping
                      </h3>
                      <p className='method-description'>Regular land freight from Turkey</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>Standard Rate</div>
                          <div className='price-value'>$4/kg</div>
                          <div className='price-details'>All packages</div>
                        </div>

                        {/* <div className='price-card promo'>
                          <div className='price-type'>Promotional</div>
                          <div className='price-value'>$1-3/kg</div>
                          <div className='price-details'>
                            Under 50kg: $3/kg
                            <br />
                            50kg+: $1/kg
                          </div>
                          <div className='price-badge'>Jun 1 - Sep 1</div>
                        </div> */}
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>Under 50kg volumetric → charged by scale weight</li>
                          <li>50kg+ volumetric → charged by max of volumetric/scale</li>
                          <li>Delivery time: 7-10 business days</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {(activeTab === 'all' || activeTab === 'greece') && (
              <div className='country-section'>
                <div className='country-header'>
                  <div className='country-flag'>
                    <img style={{ width: 20 }} src={greeceFlag} />
                  </div>
                  <div className='country-name'>GREECE</div>
                </div>

                <div className='shipping-options'>
                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-truck-loading'></i> Standard Shipping
                      </h3>
                      <p className='method-description'>Regular land freight from Greece</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>Standard Rate</div>
                          <div className='price-value'>3.5€/kg</div>
                          <div className='price-details'>All packages</div>
                        </div>

                        {/* <div className='price-card promo'> */}
                        {/* <div className='price-type'>Promotional</div> */}
                        {/* <div className='price-value'>1€/kg</div> */}
                        {/* <div className='price-details'>
                            Under 50kg: 3.5€/kg
                            <br />
                            From 50kg to 200kg: 2€/kg
                          </div> */}
                        {/* <div className='price-badge'>Jun 4 - Aug 1</div> */}
                        {/* </div> */}
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>Under 50kg volumetric → charged by scale weight</li>
                          <li>Packages of 50kg and above in volumetric or actual weight - charged by the maximum between volumetric and scale weights</li>
                          <li>Delivery time: 7-14 days</li>
                          <li>Shipments per week: 1</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>

                <div className='shipping-options'>
                  <div className='shipping-method'>
                    <div className='method-left'>
                      <h3 className='method-title'>
                        <i className='fas fa-truck-loading'></i> Road Cargo
                      </h3>
                      <p className='method-description'>Group Cargo - LTL</p>
                    </div>

                    <div className='method-right'>
                      <div className='price-options'>
                        <div className='price-card'>
                          <div className='price-type'>Standard Rate</div>
                          <div className='price-value'>Price negotiable</div>
                          <div className='price-details'>Minimum chargeable: 1 CBM</div>
                          <div className='price-details'>Maximum density: 250 kg per CBM</div>
                        </div>
                      </div>

                      <div className='conditions-list'>
                        <ul>
                          <li>Volume-based pricing</li>
                          <li>Minimum order: 1 CBM</li>
                          <li>Delivery time: 10-14 days</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className='additional-info-new'>
            <div className='info-card'>
              <div className='info-header'>
                <i className='fas fa-plus-circle'></i> Additional Services
              </div>
              <div className='info-content'>
                <div className='service-item'>
                  <span className='service-name'>24-Hour Outdoor Locker</span>
                  <span className='service-fee'>3 GEL</span>
                </div>
              </div>
            </div>

            <div className='info-card'>
              <div className='info-header'>
                <i className='fas fa-shield-alt'></i> Security Service Fees
              </div>
              <div className='info-content'>
                <p>Added to transportation cost based on declared package value</p>
                <table className='fee-table'>
                  <thead>
                    <tr>
                      <th>Declared Value</th>
                      <th>Security Fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Up to 100 GEL</td>
                      <td>1 GEL</td>
                    </tr>
                    <tr>
                      <td>100-200 GEL</td>
                      <td>2 GEL</td>
                    </tr>
                    <tr>
                      <td>200-300 GEL</td>
                      <td>3 GEL</td>
                    </tr>
                    <tr>
                      <td>300-3,000 GEL</td>
                      <td>2% of value</td>
                    </tr>
                    <tr>
                      <td>3,000-10,000 GEL</td>
                      <td>4% of value</td>
                    </tr>
                    <tr>
                      <td>10,000-20,000 GEL</td>
                      <td>8% of value</td>
                    </tr>
                    <tr>
                      <td>20,000+ GEL</td>
                      <td>12% of value</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className='calculator-cta'>
            <p>Need a precise shipping cost estimate for your package?</p>
            <div onClick={showCalculatorHandler} className='btn-pricing'>
              Use Price Calculator
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
}
